import { useState } from 'react'
import { ContainerApp, ContentApp, FooterApp, HeaderApp, LabelApp } from './Layout.app'
import { appStyles } from './app.style'
import { ButtonInApp } from './ButtonInApp.component'
import { useNavigate, useParams } from 'react-router-dom'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { api } from '../data/api'
import { Spinner } from '../components/spinner/Spinner.component'
import { copyJson } from '../helpers/general.helper'

const errorStyles = {
	color: 'red',
	fontSize: '0.875rem',
	marginTop: '0.5rem',
}

export const ForgotPassValidateApp = () => {
	const navigate = useNavigate()
	const [errors, setErrors] = useState<Record<string, string>>({})
	const [failed, setFailed] = useState(false)
	const [loading, setLoading] = useState(false)
	const params = useParams()

	const dni = params.dni as string
	const [formData, setFormData] = useState<{
		code: string
		newpass: string
		passconf: string
		dni: string
	}>({
		code: '',
		newpass: '',
		passconf: '',
		dni,
	})

	const validateForm = () => {
		const newErrors = errors === undefined ? {} : copyJson(errors)
		if (!formData.code) newErrors.code = 'El código es obligatorio'
		if (!formData.code?.length || formData.code.length <4) newErrors.code = 'El código debe tener al menos4 dígitos'
		if (!formData.newpass) newErrors.newpass = 'El nuevo pin es obligatorio'
		if (!formData.passconf) newErrors.passconf = 'La confirmación de pin es obligatoria'
		if (formData.newpass !== formData.passconf) newErrors.passconf = 'Los pins deben coincidir'
		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const handleSubmit = async () => {
		if (failed) {
			navigate('/app/login')
			return
		}

		if (!validateForm()) return

		setLoading(true)
		try {
			await api.post('/api/authp/forgotpass/verify', formData)
			navigate('/app/login')
		} catch (error) {
			console.error("### error", error)
			if (error instanceof AxiosError && error.response?.status === 401) {
				setFailed(true)
			} else {
				toast.error(error instanceof AxiosError ? error.response?.data?.message :'Error recuperando la contraseña')
			}
		} finally {
			setLoading(false)
		}
	}

	if (loading) return <Spinner />

	return (
		<ContainerApp>
			<HeaderApp title="Recuperar Contraseña" />
			<ContentApp>
				{failed && <p>El código ingresado es incorrecto. La password no ha sido cambiada. Si realmente tiene acceso a la cuenta, puede solicitar un nuevo código repitiendo el proceso de recuperación de contraseña.</p>}
				{!failed && <>
					<LabelApp label="Código de Recuperación" />
					<input 
						type="text" 
						placeholder="Código de Recuperación" 
						value={formData.code}
						onChange={(e) => setFormData({...formData, code: e.target.value})}
						style={appStyles.input} 
						required
					/>
					<LabelApp label="Nuevo Pin" />
					<input
						type="password"
						name="newpass"
						placeholder="PIN de 4 dígitos"
						style={appStyles.input}
						maxLength={4}
						minLength={4}
						value={formData.newpass}
						onChange={(e) => setFormData({...formData, newpass: e.target.value})}
						required
					/>
					{errors.newpass && <p style={errorStyles}>{errors.newpass}</p>}
					<LabelApp label="Confirmar el Pin" />
					<input
						type="password"
						name="passconf"
						placeholder="PIN de 4 dígitos"
						style={appStyles.input}
						maxLength={4}
						minLength={4}
						value={formData.passconf}
						onChange={(e) => setFormData({...formData, passconf: e.target.value})}
						required
					/>
					{errors.passconf && <p style={errorStyles}>{errors.passconf}</p>}
				</>}
			</ContentApp>
			<FooterApp>
				<ButtonInApp 
					label="Atrás"
					type="button"
					onClick={() => navigate('/app/login')}
				/>
				{!failed && <ButtonInApp 
					label="Recuperar"
					type="button"
					onClick={() => handleSubmit()}
					disabled={!formData.code || !formData.newpass || !formData.passconf}
				/>}
			</FooterApp>
		</ContainerApp>
	)
}

export const ForgotPassApp = () => {
	const navigate = useNavigate()
	// const [code, setCode] = useState('')
	const [dni, setDni] = useState('')

	const handleSubmit = async () => {
		try {
			await api.get(`/api/authp/forgotpass/${dni}`)
			navigate(`/app/forgot-pass/validate/${dni}`)
		} catch (error) {
			console.error("### error", error)
			toast.error(error instanceof AxiosError ? error.response?.data?.message :'Error recuperando la contraseña')
		}
	}

	return (
		<ContainerApp>
			<HeaderApp title="Recuperar Contraseña" />
			<ContentApp>
			<LabelApp label="Número de DNI" />
			<input 
				type="text" 
				placeholder="DNI" 
				value={dni}
				onChange={(e) => setDni(e.target.value)}
				style={appStyles.input} 
				required
			/>
			<p>Enviaremos un código de recuperación a su email. Podrá usar ese código para cambiar su contraseña.</p>
			</ContentApp>
			<FooterApp>
				<ButtonInApp 
					label="Atrás"
					type="button"
					onClick={() => navigate('/app/login')}
				/>
				<ButtonInApp 
					label="Recuperar"
					type="button"
					onClick={() => handleSubmit()}
					disabled={!dni}
				/>
			</FooterApp>
		</ContainerApp>
	)

}